import { render } from "./VerificationBadge.vue?vue&type=template&id=5fe7b50c&scoped=true"
import script from "./VerificationBadge.vue?vue&type=script&lang=js"
export * from "./VerificationBadge.vue?vue&type=script&lang=js"

import "./VerificationBadge.vue?vue&type=style&index=0&id=5fe7b50c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe7b50c"]])

export default __exports__